import { Outlet } from "react-router-dom";
import BottomTabs from "../../components/dashboard/BottomTabs";
import { AppPaths } from "../../utils/AppPaths";
import { setActiveTab, tabData } from "../../redux/rootSlice";
import ReferralModalHost from "../../components/ReferralModalHost";

const Dashboard = () => {

  return (
    <div className="flex flex-col h-svh" style={{ overflowX: 'hidden' }}>
      <Outlet />
      <BottomTabs tabs={tabData} />
      <ReferralModalHost />
    </div>
  );
};

export default Dashboard;
